(function(){
  'use strict';

  var CURRENCY_ALIASES = {
    AU:'AUD',
    AUS:'AUD',
    AUD:'AUD',
    US:'USD',
    USA:'USD',
    USD:'USD',
    UK:'GBP',
    GB:'GBP',
    GBP:'GBP',
    EU:'EUR',
    EUR:'EUR',
    NZ:'NZD',
    NZD:'NZD'
  };

  var CURRENCY_FIELDS = {
    AUD:'aud',
    USD:'usd',
    GBP:'gbp',
    EUR:'eur',
    NZD:'nzd'
  };

  var CURRENCY_SYMBOLS = {
    AUD:'A$',
    USD:'US$',
    GBP:'\u00A3',
    EUR:'\u20AC',
    NZD:'NZ$'
  };

  function toArray(list){
    return Array.prototype.slice.call(list || []);
  }

  function normalizeCurrency(value){
    var key = String(value || '').trim().toUpperCase();
    return CURRENCY_ALIASES[key] || key;
  }

  function currencyField(currency){
    return CURRENCY_FIELDS[normalizeCurrency(currency)] || String(currency || '').toLowerCase();
  }

  function parseNumber(value){
    if (value === null || value === undefined) return NaN;
    var clean = String(value).replace(/,/g, '').replace(/[^0-9.-]/g, '').trim();
    if (!clean) return NaN;
    return parseFloat(clean);
  }

  function formatThousands(value){
    return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function formatMoney(currency, value, options){
    var amount = Number(value);
    var settings = options || {};
    if (!isFinite(amount)) return '';
    var symbol = CURRENCY_SYMBOLS[normalizeCurrency(currency)] || '';

    if (settings.cents === false) {
      var rounded = Math.round(amount);
      return symbol + formatThousands(rounded);
    }

    return symbol + formatThousands(amount.toFixed(2));
  }

  function getScopedElements(root, selector){
    var found = [];
    if (!root) return found;
    if (root.matches && root.matches(selector)) found.push(root);
    return found.concat(toArray(root.querySelectorAll(selector)));
  }

  function onReady(callback){
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, {once:true});
    } else {
      callback();
    }
  }

  function dataValue(el, names){
    for (var i = 0; i < names.length; i++) {
      var attr = names[i];
      if (el.hasAttribute(attr)) return el.getAttribute(attr);
    }
    return '';
  }

  function rowPrice(row, currency, type){
    var field = currencyField(currency);
    return dataValue(row, [
      'data-' + field + '-' + type,
      'data-' + normalizeCurrency(currency).toLowerCase() + '-' + type,
      'data-' + currency.toLowerCase() + '-' + type
    ]);
  }

  function rowMinimum(row){
    var explicit = parseNumber(row.getAttribute('data-qty'));
    if (isFinite(explicit)) return explicit;

    var text = row.querySelector('.solos-price-quantity, td');
    return parseNumber(text ? text.textContent : '');
  }

  function chooseDefaultCurrency(container, buttons){
    var configured = normalizeCurrency(container.getAttribute('data-default-currency'));
    var available = buttons.map(function(button){
      return normalizeCurrency(button.getAttribute('data-currency') || button.getAttribute('data-cur') || button.textContent);
    });

    if (available.indexOf(configured) !== -1) return configured;

    var pressed = buttons.filter(function(button){
      return button.getAttribute('aria-pressed') === 'true';
    })[0];

    if (pressed) {
      return normalizeCurrency(pressed.getAttribute('data-currency') || pressed.getAttribute('data-cur') || pressed.textContent);
    }

    return available[0] || 'AUD';
  }

  function updatePriceFromCards(root, currency){
    var cards = getScopedElements(root, '[data-solos-price-from], [data-from-price], .from[data-from]');

    cards.forEach(function(card){
      var field = currencyField(currency);
      var raw = dataValue(card, [
        'data-' + field + '-price',
        'data-' + field + '-from',
        'data-price-' + field
      ]);
      var price = parseNumber(raw);

      if (!isFinite(price)) return;

      var suffix = card.getAttribute('data-price-suffix') || ' /pr';
      card.textContent = 'from ' + formatMoney(currency, price) + suffix;
    });
  }

  function initPricing(root){
    var containers = getScopedElements(root, '[data-solos-pricing]');

    containers.forEach(function(container){
      if (container.__solosPricing && container.__solosPricing.destroy) {
        container.__solosPricing.destroy();
      }

      var buttons = toArray(container.querySelectorAll('[data-currency], [data-cur]'));
      var rows = toArray(container.querySelectorAll('tbody tr'));

      if (!buttons.length || !rows.length) return;

      function setCurrency(currency){
        var active = normalizeCurrency(currency);

        buttons.forEach(function(button){
          var buttonCurrency = normalizeCurrency(
            button.getAttribute('data-currency') ||
            button.getAttribute('data-cur') ||
            button.textContent
          );
          button.setAttribute('aria-pressed', buttonCurrency === active ? 'true' : 'false');
        });

        rows.forEach(function(row){
          var standardRaw = rowPrice(row, active, 'standard');
          var expressRaw = rowPrice(row, active, 'express');
          var standard = parseNumber(standardRaw);
          var express = parseNumber(expressRaw);
          var minimum = rowMinimum(row);
          var hasStandard = String(standardRaw || '').trim() !== '' && isFinite(standard);
          var hasExpress = String(expressRaw || '').trim() !== '' && isFinite(express);

          row.hidden = !(hasStandard && hasExpress);
          if (row.hidden) return;

          var standardCell = row.querySelector('[data-standard]');
          var expressCell = row.querySelector('[data-express]');
          var totalCell = row.querySelector('[data-total]');

          if (standardCell) standardCell.textContent = formatMoney(active, standard);
          if (expressCell) expressCell.textContent = formatMoney(active, express);
          if (totalCell) {
            totalCell.textContent = isFinite(minimum) ? formatMoney(active, standard * minimum, {cents:false}) : '';
          }
        });

        updatePriceFromCards(document, active);

        if (window.dataLayer) {
          window.dataLayer.push({event:'currency_change', cur:active});
        }
      }

      var listeners = buttons.map(function(button){
        var handler = function(){
          var currency = button.getAttribute('data-currency') || button.getAttribute('data-cur') || button.textContent;
          setCurrency(currency);
        };

        button.addEventListener('click', handler);
        return {button:button, handler:handler};
      });

      container.__solosPricing = {
        destroy:function(){
          listeners.forEach(function(item){
            item.button.removeEventListener('click', item.handler);
          });
        },
        setCurrency:setCurrency
      };

      setCurrency(chooseDefaultCurrency(container, buttons));
    });
  }

  function initStats(root){
    var stats = getScopedElements(root, '.solos-stat[data-animate]');
    if (!stats.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function reveal(stat){
      if (stat.__solosStatDone) return;
      stat.__solosStatDone = true;
      stat.classList.add('is-visible');

      var number = stat.querySelector('[data-to]');
      if (!number || reduce) return;

      var target = parseInt(number.getAttribute('data-to'), 10);
      if (!isFinite(target)) return;

      var suffix = number.getAttribute('data-suffix') || '';
      var group = number.hasAttribute('data-group');
      var start = null;
      var duration = 1400;

      function render(value){
        var text = Math.round(value).toString();
        if (group) text = formatThousands(text);
        number.textContent = text + suffix;
      }

      function tick(timestamp){
        if (start === null) start = timestamp;
        var progress = Math.min(1, (timestamp - start) / duration);
        var eased = 1 - Math.pow(1 - progress, 4);
        render(target * eased);
        if (progress < 1) requestAnimationFrame(tick);
        else render(target);
      }

      requestAnimationFrame(tick);
    }

    if (!('IntersectionObserver' in window)) {
      stats.forEach(reveal);
      return;
    }

    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        observer.unobserve(entry.target);
      });
    }, {threshold:0.35});

    stats.forEach(function(stat){
      if (!stat.__solosStatDone) observer.observe(stat);
    });
  }

  function initReviewCarousels(root){
    var tracks = getScopedElements(root, '.solos-reviews-track');

    tracks.forEach(function(track){
      if (track.__solosReviewsInit) return;
      track.__solosReviewsInit = true;

      var section = track.closest('.solos-section') || track.parentElement;
      if (!section) return;

      var reviews = toArray(track.querySelectorAll('.solos-review'));
      var controls = section.querySelector('.solos-review-controls');
      if (!reviews.length || !controls) return;

      var prev = controls.querySelector('[data-review-prev], .solos-review-arrow:first-child');
      var next = controls.querySelector('[data-review-next], .solos-review-arrow:last-child');
      var dotsWrap = controls.querySelector('.solos-review-dots');

      function currentIndex(){
        var left = track.scrollLeft;
        var widths = reviews.map(function(review){ return Math.abs(review.offsetLeft - left); });
        var min = Math.min.apply(Math, widths);
        return widths.indexOf(min);
      }

      function go(index){
        var safe = Math.max(0, Math.min(reviews.length - 1, index));
        track.scrollTo({left:reviews[safe].offsetLeft, behavior:'smooth'});
        update(safe);
      }

      function update(index){
        if (!dotsWrap) return;
        toArray(dotsWrap.querySelectorAll('button')).forEach(function(dot, i){
          dot.classList.toggle('is-active', i === index);
          dot.setAttribute('aria-pressed', i === index ? 'true' : 'false');
        });
      }

      if (dotsWrap && !dotsWrap.children.length) {
        reviews.forEach(function(_, i){
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', 'Show review ' + (i + 1));
          dot.addEventListener('click', function(){ go(i); });
          dotsWrap.appendChild(dot);
        });
      }

      if (prev) prev.addEventListener('click', function(){ go(currentIndex() - 1); });
      if (next) next.addEventListener('click', function(){ go(currentIndex() + 1); });

      track.addEventListener('scroll', function(){
        window.clearTimeout(track.__solosReviewTimer);
        track.__solosReviewTimer = window.setTimeout(function(){
          update(currentIndex());
        }, 80);
      }, {passive:true});

      update(0);
    });
  }

  function initInlineForms(root){
    var triggers = getScopedElements(root, '[data-solos-form-toggle], [data-inline-form-toggle], [data-solos-inline-form-toggle]');

    triggers.forEach(function(trigger){
      if (trigger.__solosInlineInit) return;
      trigger.__solosInlineInit = true;

      trigger.addEventListener('click', function(event){
        var selector = trigger.getAttribute('data-solos-form-toggle') || trigger.getAttribute('data-inline-form-toggle');
        var controls = trigger.getAttribute('aria-controls');
        var href = trigger.getAttribute('href');

        if (!selector && controls) selector = '#' + controls;
        if (!selector && href && href.charAt(0) === '#') selector = href;

        var panel = selector ? document.querySelector(selector) : document.querySelector('.solos-inline-form');
        if (!panel) return;

        event.preventDefault();
        panel.classList.add('is-open');
        panel.removeAttribute('hidden');
        panel.removeAttribute('inert');
        panel.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');

        window.requestAnimationFrame(function(){
          panel.scrollIntoView({behavior:'smooth', block:'start'});
        });
      });
    });

    getScopedElements(root, '.solos-inline-form__close').forEach(function(close){
      if (close.__solosInlineCloseInit) return;
      close.__solosInlineCloseInit = true;

      close.addEventListener('click', function(){
        var panel = close.closest('.solos-inline-form');
        if (!panel) return;

        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
        panel.setAttribute('inert', '');

        var panelId = panel.id;
        if (panelId) {
          document.querySelectorAll('[aria-controls="' + panelId + '"]').forEach(function(trigger){
            trigger.setAttribute('aria-expanded', 'false');
          });
        }
      });
    });
  }
  function initSticky(root){
    var stickies = getScopedElements(root, '.solos-sticky');
    if (!stickies.length || !('IntersectionObserver' in window)) return;

    stickies.forEach(function(sticky){
      if (sticky.__solosStickyInit) return;
      sticky.__solosStickyInit = true;

      var hero = document.querySelector('.solos-hero');
      if (!hero) return;

      var observer = new IntersectionObserver(function(entries){
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, {rootMargin:'-120px 0px 0px 0px'});

      observer.observe(hero);
    });
  }

  function initRevealLists(root){
    var lists = getScopedElements(root, '[data-state-bars], [data-location-bars]');
    if (!lists.length) return;

    function reveal(el){
      el.classList.add('is-visible');
      el.classList.add('in');
    }

    if (!('IntersectionObserver' in window)) {
      lists.forEach(reveal);
      return;
    }

    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        observer.unobserve(entry.target);
      });
    }, {threshold:0.25});

    lists.forEach(function(list){
      if (list.__solosRevealInit) return;
      list.__solosRevealInit = true;
      observer.observe(list);
    });
  }

  function initSolos(root){
    var scope = root || document;
    initSolosGifs(root);
    initPricing(scope);
    initStats(scope);
    initReviewCarousels(scope);
    initInlineForms(scope);
    initSticky(scope);
    initRevealLists(scope);
  }

  window.SolosLanding = window.SolosLanding || {};
  window.SolosLanding.init = initSolos;
  window.SolosLanding.formatMoney = formatMoney;

  onReady(function(){
    initSolos(document);
  });

  document.addEventListener('shopify:section:load', function(event){
    initSolos(event.target);
  });

  document.addEventListener('shopify:section:select', function(event){
    initSolos(event.target);
  });

  document.addEventListener('shopify:block:select', function(event){
    initSolos(event.target);
  });
})();

function initSolosGifs(root) {
  root = root || document;

  var gifs = root.querySelectorAll(
    'img[data-solos-gif-src]:not([data-gif-ready])'
  );

  gifs.forEach(function (img) {
    img.setAttribute('data-gif-ready', '1');

    var gifSrc = img.getAttribute('data-solos-gif-src');

    if (!gifSrc) return;

    function loadGif() {
      if (img.getAttribute('data-gif-loaded') === '1') return;

      img.setAttribute('data-gif-loaded', '1');
      img.src = gifSrc;
    }

    if (!('IntersectionObserver' in window)) {
      loadGif();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          loadGif();
          observer.unobserve(img);
        });
      },
      {
        threshold: 0.1,
        rootMargin: '150px 0px'
      }
    );

    observer.observe(img);
  });
}